import { extendObservable, action } from 'mobx';

class ScreenHelper {
  constructor() {
    this.PORTRAIT = "portrait";
    this.LANDSCAPE = "landscape";
    extendObservable(this, {
      orientation: this.LANDSCAPE,
    });
    //init
    this.updateOrientation();
    // register
    window.onresize = this.updateOrientation;
  }

  updateOrientation = action(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const newOrientation = (width > height) ? this.LANDSCAPE : this.PORTRAIT;
    // only update if different
    if (newOrientation !== this.orientation) {
      this.orientation = newOrientation;
    }
  });
}

const screenHelper = new ScreenHelper();

export default screenHelper;
export { screenHelper }; // why?


// WEBPACK FOOTER //
// ./src/tools/ScreenHelper.js